// Backend endpoint + admin token.
//
// Thứ tự ưu tiên cấu hình:
//   1. window.__APP_CONFIG__  -> ghi bởi file runtime-config.js (trình cài đặt tạo lúc
//      deploy, KHÔNG cần build lại FE). Đây là cách dùng cho bản build sẵn (production).
//   2. process.env.REACT_APP_*  -> dùng khi chạy/build ở môi trường dev (.env).
//   3. Giá trị mặc định cuối cùng.
const RT =
  (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

function pick(runtimeVal, envVal, fallback) {
  if (typeof runtimeVal === "string" && runtimeVal.trim()) return runtimeVal.trim();
  if (typeof envVal === "string" && envVal.trim()) return envVal.trim();
  return fallback;
}

export const API_BASE = pick(
  RT.API_BASE,
  process.env.REACT_APP_API_BASE,
  "https://server.cookie.pro.vn"
);

// Khớp MONITOR_TOKEN trong .env BackendNode
export const ADMIN_TOKEN = pick(
  RT.ADMIN_TOKEN,
  process.env.REACT_APP_ADMIN_TOKEN,
  "monitor-secret-token"
);
